import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
export default function PageHeader({ title, subtitle, icon: Icon }) {
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3,
            p: { xs: 2, sm: 3 },
            borderRadius: 1,
            background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: 'primary.contrastText',
        }, children: [_jsx(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: { xs: 48, sm: 56 },
                    height: { xs: 48, sm: 56 },
                    borderRadius: 2,
                    bgcolor: 'rgba(255,255,255,0.15)',
                    flexShrink: 0,
                }, children: _jsx(Icon, { sx: { fontSize: { xs: 28, sm: 32 } } }) }), _jsxs(Box, { children: [_jsx(Typography, { variant: "h5", component: "h1", fontWeight: 700, children: title }), _jsx(Typography, { variant: "body2", sx: { opacity: 0.85, mt: 0.25 }, children: subtitle })] })] }));
}
